/**
 * Vertragsmanagement API
 * REST-Api für das Conergos Vertragsmanagement Tool.
 *
 * OpenAPI spec version: 0.1.0
 * Contact: marius.junak@scorpius-forge.de
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { MailSettings, TenantDto } from '@bo-client/shared/models/tenantDto';

import { Configuration } from '@bo-client/core/configuration';
import { ConfigService } from '@bo-client/config/config.service';
import { WINDOW } from '@bo-client/core/provider/window.provider';

@Injectable()
export class TenantService {
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Inject(WINDOW) private window: Window,
    @Optional() configuration: Configuration,
    private configService: ConfigService
  ) {}

  getTenant(): Observable<any> {
    const hostName = this.getParamFromUrl('hostName') ? this.getParamFromUrl('hostName') : this.getHostname();
    const tenantId = this.getParamFromUrl('tenantId') ? this.getParamFromUrl('tenantId') : null;
    if (tenantId) {
      return this.getTenantById(tenantId);
    } else {
      return this.getTenantByHostname(hostName);
    }
  }

  getParamFromUrl(name) {
    const results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return null;
    }
    return results[1] || null;
  }

  /**
   * getTenants
   * gets all the available tenants for the current user
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTenantById(id: string, observe: any = 'body', reportProgress = false): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];

    return this.httpClient
      .skipErrorHandler()
      .get<any>(`${this.configService.getSettings('serverUrl')}/tenants/` + id, {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      });
  }

  getHostname(): string {
    return this.window.location.hostname;
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  public createTenant(body: { id: string; displayName: string }): Observable<any> {
    let headers = this.defaultHeaders;
    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const consumes: string[] = ['application/json'];

    return this.httpClient.post<TenantDto>(
      `${this.configService.getSettings('serverUrl')}/data/tenants`,
      body,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers
      }
    );
  }

  /**
   * getTenants
   * gets all the available tenants for the current user
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTenants(observe: any = 'body', reportProgress = false): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];

    // ToDo: Statt hier fix 40 Mandanten abzufrufen, sollte spätestens ab 41 eine Pagination in der Mandanten Tabelle eingebaut werden.
    // (Wird wahrscheinlich im Zuge der Umstellung aller Tabellen auf mat-table mit mat-paginator geschehen)
    return this.httpClient.get<any>(`${this.configService.getSettings('serverUrl')}/data/tenants?size=100`, {
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * getTenants
   * gets all the available tenants for the current user
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTenantByHostname(
    hostname: string,
    observe: any = 'body',
    reportProgress = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];

    return this.httpClient
      .skipErrorHandler()
      .get<any>(`${this.configService.getSettings('serverUrl')}/tenants/byhostname?hostName=` + hostname, {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      });
  }

  public patchTenant(id: string, body: TenantDto): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.patch<TenantDto>(
      `${this.configService.getSettings('serverUrl')}/data/tenants/${encodeURIComponent(String(id))}`,
      body,
      {
        params: {},
        withCredentials: this.configuration.withCredentials,
        headers: headers
      }
    );
  }

  public getTenantMailSettings(tenantId: string): Observable<MailSettings> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.get<MailSettings>(
      `${this.configService.getSettings('serverUrl')}/tenants/${encodeURIComponent(
        String(tenantId)
      )}/mail-settings`,
      {
        params: {},
        withCredentials: this.configuration.withCredentials,
        headers: headers
      }
    );
  }

  public putTenantMailSettings(tenantId: string, body: MailSettings): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.put<MailSettings>(
      `${this.configService.getSettings('serverUrl')}/tenants/${encodeURIComponent(
        String(tenantId)
      )}/mail-settings`,
      body,
      {
        params: {},
        withCredentials: this.configuration.withCredentials,
        headers: headers
      }
    );
  }

  public putTenant(id: string, body: TenantDto): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.put<TenantDto>(
      `${this.configService.getSettings('serverUrl')}/data/tenants/${encodeURIComponent(String(id))}`,
      body,
      {
        params: {},
        withCredentials: this.configuration.withCredentials,
        headers: headers
      }
    );
  }
}
